module Bookhus {

    export class Bookingpopup {
        private popup;
        private header;
        private body;
        private currentHouseId: number;
        private currentDate: Date;
        private locale = "da";
        private showBookingCalendarButton = false;
        private spejder: boolean;
        private hasEventModule: boolean;

        private localizedStrings = {
            reservation: {
                "da": "Booking",
                "en-GB": "Booking",
                "de-DE": "Booking",
                "sv-SE": "Booking",
                "no": "Bestilling"
            },
            låst: {
                "da": "Låst",
                "en-GB": "Locked",
                "de-DE": "verschlossen",
                "sv-SE": "Låst",
                "no": "Låst"
            },
            wish: {
                "da": "Ønske",
                "en-GB": "Wish",
                "de-DE": "Wünschen",
                "sv-SE": "Önskar",
                "no": "Ønske"
            },
            event: {
                "da": "Begivenhed",
                "en-GB": "Event",
                "de": "Ereignis",
                "sv": "Händelse",
                "no": "Begivenhet"
            },
            booking: {
                "da": "Booking",
                "en-GB": "Booking",
                "de-DE": "Booking",
                "sv-SE": "Booking",
                "no": "Bestilling"
            },
            bruger: {
                "da": "Bruger",
                "en-GB": "User",
                "de-DE": "Benutzer",
                "sv-SE": "Användare",
                "no": "Bruker"
            },
            mobil: {
                "da": "Mobil",
                "en-GB": "Mobile",
                "de-DE": "Handy",
                "sv-SE": "Mobil",
                "no": "Mobil"
            },
            email: {
                "da": "Email",
                "en-GB": "Email",
                "de-DE": "Email",
                "sv-SE": "Email",
                "no": "E-post"
            },
            address: {
                "da": "Adresse",
                "en-GB": "Addresse",
                "de-DE": "Addresse",
                "sv-SE": "Addresse",
                "no": "Addresse"
            },
            fra: {
                "da": "Fra",
                "en-GB": "From",
                "de-DE": "Aus",
                "sv-SE": "Från",
                "no": "Fra"
            },
            til: {
                "da": "Til",
                "en-GB": "To",
                "de-DE": "Für",
                "sv-SE": "Till",
                "no": "Til"
            },
            håndter: {
                "da": "Håndter",
                "en-GB": "Handle",
                "de-DE": "Handle",
                "sv-SE": "Handle",
                "no": "Åpen"
            },
            håndterOrdre: {
                "da": "Åben ordre",
                "en-GB": "Open order",
                "de-DE": "Offen bestellen",
                "sv-SE": "Öppen order",
                "no": "Åpen ordre"
            },
            companyId: {
                "da": "Kunde id",
                "en-GB": "Company id",
                "de-DE": "Kundennummer",
                "sv-SE": "Kund-id",
                "no": "Kunde-id"
            },
            department: {
                "da": "Afdeling",
                "en-GB": "Department",
                "de-DE": "Abteilung",
                "sv-SE": "Avdelning",
                "no": "Avdeling"
            },
            availabilityLock: {
                "da": "Rådighedslåsning",
                "en-GB": "Availability lock",
                "de-DE": "Verfügbar Schloss",
                "sv-SE": "Tillgängligt lås",
                "no": "Tilgjengelig lås"
            },
            noBookingRegistered: {
                da: "Der er ikke registreret nogen bookinger på denne dato.",
                "en-GB": "No bookings have been registered on this date.",
                de: "Für dieses Datum wurden keine Buchungen registriert.",
                sv: "Inga bokningar har registrerats detta datum.",
                no: "Ingen bestillinger er registrert på denne datoen."
            },
            goToBookingCalendar: {
                da: "Gå til bookingkalender",
                "en-GB": "Go to booking calendar",
                de: "Gehen Sie zum Buchungskalender",
                sv: "Gå till bokningskalendern",
                no: "Gå til bestillingskalender"
            },
            close: {
                da: "Luk",
                "en-GB": "Close",
                de: "Schließen",
                sv: "Stäng",
                no: "Lukk"
            },
            usersOnWaitingList: {
                da: "Brugere på venteliste",
                "en-GB": "Users on waiting list",
                de: "Benutzer auf Warteliste",
                sv: "Användare på väntelista",
                no: "Brukere på venteliste"
            },
            numberOfGuests: {
                da: "Antal gæster",
                "en-GB": "Number of guests",
                de: "Anzahl der Gäste",
                sv: "Användare på väntelista",
                no: "Brukere på venteliste"
            },
            contractnumber: {
                da: "Kontraktnummer",
                "en-GB": "Contract number",
                de: "Vertragsnummer",
                sv: "Antal gäster",
                no: "Antall gjester"
            }
        };


        constructor(locale: string, showBookingCalendarButton: boolean, spejder: boolean = false, hasEventModule: boolean = false) {
            this.locale = locale;
            this.showBookingCalendarButton = showBookingCalendarButton;
            this.drawPopup();
            this.popup = $("#bookingpopup");
            this.header = this.popup.find(".modal-title");
            this.body = this.popup.find(".modal-body");
            this.setPopupEvents();
            this.reset();
            this.spejder = spejder;
            this.hasEventModule = hasEventModule;
        }


        public showPopup(houseId: number, date: Date, isAdmin: boolean): Promise<JQuery> {
            return new Promise((resolve, reject) => {
                this.currentHouseId = houseId;
                this.currentDate = date;

                $.getJSON("/api/overview/GetInfoForDay?houseId=" + houseId + "&selectedDate=" + date.formatDate("yy-mm-dd") + "&locale=" + this.locale, (data) => {
                    this.drawContent(data, isAdmin);
                }).always(() => {
                    $.getJSON("/api/QueueList/GetQueueListForHouse?houseId=" + houseId + "&selectedDate=" + date.formatDate("yy-mm-dd"), (data) => {
                        this.drawQueueList(data);
                        resolve(this.body);
                    });
                });

                this.popup.modal("show");
            });
        }

        public showLockInfo(houseId: number, date: Date, isAdmin: boolean): void {
            var self = this;
            this.currentHouseId = houseId;
            this.currentDate = date;
            $.getJSON("/api/overview/GetInfoForDay?houseId=" +
                houseId +
                "&selectedDate=" +
                date.formatDate("yy-mm-dd") +
                "&locale=" +
                this.locale,
                (data) => {
                    this.drawContent(data, isAdmin);
                });

            this.popup.modal("show");
        }

        public drawQueueList(data) {
            if (data.length <= 0) {
                return;
            }
            var body = `<hr/><strong>${this.localizedStrings.usersOnWaitingList[this.locale]}</strong><br/>`;
            data.forEach(name => {
                body += name + "<br/>";
            });
            this.body.append(body);
        }

        public drawContent(data, isAdmin = false) {
            var locale = this.locale;
            var localized = this.localizedStrings;
            var body = "";
            data.forEach((booking) => {
                if (booking.id === -1) {
                    // ID -1 indeholder generel info
                    var headerDate = this.currentDate.toString("dd-MM-yyyy");
                    this.header.html(`${headerDate}: ${booking.title}`);

                } else {
                    // Adskil poster
                    if (body !== "") {
                        body += "<hr/>";
                    }

                    // Forbered indholdselementer
                    var type = localized.reservation[locale];
                    if (booking.type === 2) {
                        type = localized.låst[locale];
                    } else if (booking.type === 0) {
                        type = localized.wish[locale];
                    }
                    else if (booking.type === -7) {
                        type = localized.availabilityLock[locale];
                    }

                    if (booking.type === 0 && this.hasEventModule) {
                        type = localized.event[locale];
                    }

                    var startDate = new Date(Date.parse(booking.startdate)).toString("dd-MM-yyyy H:mm");
                    var endDate = new Date(Date.parse(booking.enddate)).toString("dd-MM-yyyy H:mm");

                    // Sammensæt post
                    //body += `<a href="/handlereservation.aspx?rid=${booking.id}" class="btn btn-default btn-sm pull-right">${localized.håndter[locale]}</a>`;
                    if (isAdmin && this.spejder && booking.type !== 2) {
                        body += `<a href="/admin/scout/scoutorders/edit/${booking.orderId}" class="btn btn-outline-primary btn-sm float-right">${localized.håndter[locale]}</a>`;
                    }
                    else if (isAdmin && booking.type != -7) {
                        body += `<a href="/admin/booking/edit/${booking.id}" class="btn btn-outline-primary btn-sm float-right">${localized.håndter[locale]}</a>`;
                    }
                    else if (isAdmin && booking.type == -7) {
                        body += `<a href="/admin/exchangerules/editavailabilitylock/${booking.id}" class="btn btn-outline-primary btn-sm float-right">${localized.håndter[locale]}</a>`;
                    }

                    if (booking.orderId && !this.spejder) {
                        body += `<a style="margin-right: 5px;" href="/admin/shoppingcart/edit/${booking.orderId}" class="btn btn-outline-primary btn-sm float-right">${localized.håndterOrdre[locale]}</a>`;
                    }

                    if (booking.type != -7) {
                        body += `<strong>${booking.id} &nbsp;·&nbsp; ${type}</strong><br/>`;
                        if (booking.periodDescription && booking.periodDescription.trim().length > 0) {
                            body += `<small>${booking.periodDescription}</small><br/>`;
                        }
                        if (booking.userFullname && booking.userFullname.trim().length > 0) {
                            body += `${localized.bruger[locale]}:&nbsp; ${booking.userFullname}<br/>`;
                        }
                        if (booking.address && booking.address.trim().length > 0) {
                            body += `${localized.address[locale]}:&nbsp; ${booking.address}<br/>`;
                        }
                        if (booking.mobilenumber && booking.mobilenumber.trim().length > 0) {
                            body += `${localized.mobil[locale]}:&nbsp; ${booking.mobilenumber} &nbsp;`;
                        }
                        if (booking.email && booking.email.trim().length > 0) {
                            body += `·&nbsp; ${localized.email[locale]}:&nbsp; ${booking.email}`;
                        }
                        body += "<br/>";
                        
                    }
                    else {
                        body += `<strong>${type} - ${booking.bookingId}</strong><br/>`;
                        body += `${localized.companyId[locale]}:&nbsp; ${booking.companyId}<br/>`;
                        body += `${localized.department[locale]}:&nbsp; ${booking.relationship}<br/>`;
                    }

                    if (this.spejder) {
                        body += `${this.localizedStrings.numberOfGuests[this.locale]}: ${booking.personcount} <br/> ${this.localizedStrings.contractnumber[this.locale]}: ${booking.contractnumber} <br/>`;    
                    }
                    body += `${localized.fra[locale]}:&nbsp; ${startDate} &nbsp; ${localized.til[locale]}:&nbsp; ${endDate}<br/>`;

                }
            });
            if (body === "") {
                body = localized.noBookingRegistered[locale];
            }
            this.body.html(body);
        }

        private drawPopup(): void {
            var bookingCalendarButton = "";
            if (this.showBookingCalendarButton) {
                bookingCalendarButton = `<button type="button" class="btn btn-primary" id="btn-bookng-calendar">${this.localizedStrings.goToBookingCalendar[this.locale]}</button>`;
            }
            var modal = `
                <div class="modal fade bookingpopup" role="dialog" id="bookingpopup">
                    <div class= "modal-dialog">
                        <div class= "modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title"></h5>
                                <button type="button" class="close text-secondary opacity-1" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body"></div>
                            <div class="modal-footer">
                                ${bookingCalendarButton}
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">${this.localizedStrings.close[this.locale]}</button>
                            </div>
                        </div>
                    </div>
                </div>`;
            $("body").append(modal);
        }

        private setPopupEvents(): void {
            this.popup.find("#btn-bookng-calendar").on("click", () => {
                this.goToBookingCalendar();
            });
            this.popup.on("hidden.bs.modal", () => {
                this.reset();
            });
        }

        private reset(): void {
            this.currentHouseId = 0;
            this.currentDate = null;
            this.header.html("&nbsp;");
            this.body.html(`<img src="/Content/siteimages/loadericons/ajax-loader.gif"/>`);
            
        }

        private goToBookingCalendar(): void {
            if (this.currentHouseId !== 0 && this.currentDate !== null) {
                window.location.href = `/book/${this.currentHouseId}?date=${this.currentDate.toString("dd-MM-yyyy")}`;
            }
        }

    }

} 